function language(state = 'al', action = {},) {
    if (action.type == 'UPDATE_LANGUAGE'){
        return action.data
    }

    return state
}

export { language }
